import { StepOption } from '@order/steps/types'
import TileOption from '@ui/tiles/TileOption'
import TileOptionDebug from 'features/debug/components/TileOptionDebug'
import PricePackage from '@order/PricePackage'
import { optionGradient } from '@order/PricePackage/styles'
import { useTranslation } from 'react-i18next'
import { getCTA, useGetLabel } from '@order/steps/helpers'

export type OptionProps = StepOption & {
  options: number
  isRecommended?: boolean
}

export default function OptionDefault({ options, ...props }: OptionProps) {
  const { t } = useTranslation()

  const {
    title,
    desc,
    label,
    image,
    price,
    name,
    pricePrefix,
    priceSuffix,
    priceValue,
    recommended,
    onPress,
    colorOption,
    value,
    id,
    // colors,
    cta,
    variantId,
    magicGlow,
    isRecommended,
  } = props

  const _label = useGetLabel({ label, price, recommended })
  const _cta = getCTA(cta)
  const priceText = _cta ? t(_cta) : undefined

  const tileOptionProps = {
    name,
    value,
    id,
    variantId,
    title,
  }

  return (
    <TileOption
      {...tileOptionProps}
      desc={desc || undefined}
      label={_label}
      onPress={onPress}
      image={image}
      // magicGlow={magicGlow} // NOTE: not used anymore
      isRecommended={isRecommended}
      backgroundGradient={colorOption ? optionGradient[colorOption] : undefined}
      blurMode="backdropFilter"
      debugContent={<TileOptionDebug item={tileOptionProps} />}
      cta={
        <PricePackage
          price={price}
          prefix={pricePrefix}
          suffix={priceSuffix}
          priceValue={priceValue}
          text={priceText}
          colorOption={colorOption}
        />
      }
    />
  )
}
